import { RootState } from '@app/store';

export const selectIsAuthenticated = (state: RootState) => {
    const tokens = state.auth.tokens;
    if (!tokens) return false;
    
    // Проверяем срок действия токена
    const expiryTime = new Date(tokens.expiry).getTime();
    const currentTime = new Date().getTime();
    
    return tokens.accessToken && expiryTime > currentTime;
};

export const selectTokens = (state: RootState) => state.auth.tokens;

export const selectAccessToken = (state: RootState) => state.auth.tokens?.accessToken;

export const selectRefreshToken = (state: RootState) => state.auth.tokens?.refreshToken;

export const selectTokenExpiry = (state: RootState) => state.auth.tokens?.expiry;

export const selectCurrentToken = (state: RootState) => state.auth.tokens?.accessToken;